import { queryAgg } from '@confluence/query-preloader-tools/entry-points/graphql';

import NotificationsButtonQuery, {
	type NotificationsButtonQuery$data,
	type NotificationsButtonQuery$variables,
} from './__generated__/NotificationsButtonQuery.graphql';

export const preloadUnseenNotificationCount = () => {
	return queryAgg<NotificationsButtonQuery$data, NotificationsButtonQuery$variables>({
		query: NotificationsButtonQuery,
	});
};
